import { request } from "../utils/request.js"


export const commodityCategory_addNew = (pojo, args) => request({
    url: 'commodityCategory/addNew',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const commodityCategory_update = (pojo, args) => request({
    url: 'commodityCategory/update',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const commodityCategory_findByPage = (pojo, args) => request({
    url: 'commodityCategory/findByPage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const commodityCategory_findPageForSelect = (pojo, args) => request({
    url: 'commodityCategory/findPageForSelect',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const commodityCategory_findListForManage = (pojo, args) => request({
    url: 'commodityCategory/findListForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const commodityCategory_findListForSelect = (pojo, args) => request({
    url: 'commodityCategory/findListForSelect',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const commodityCategory_findListForFilterCommodity = (args) => request({
    url: 'commodityCategory/findListForFilterCommodity',
    method: 'GET',
    showFailMessage: true,
    ...args
})


export const commodityCategory_findById = (id, args) => request({
    url: 'commodityCategory/findById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})

export const commodityCategory_changeFrozenStatus = (id, args) => request({
    url: 'commodityCategory/changeFrozenStatus',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const commodityCategory_changeDefaultMark = (id, args) => request({
    url: 'commodityCategory/changeDefaultMark',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const commodityCategory_getDefault = (args) => request({
    url: 'commodityCategory/getDefault',
    method: 'GET',
    showFailMessage: false,
    showSuccessMessage: false,
    ...args
})

export const commodityCategory_deleteById = (id, args) => request({
    url: 'commodityCategory/deleteById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})


// WEBPACK FOOTER //
// ./src/api/commodityCategory.js